/* eslint-disable no-unused-expressions */
import { SendToast } from "@networkraildigitalfactory/components";
import useCloseObjectiveStore from "../../stores/useCloseObjectiveStore";
import { useObjectives } from "../useAPI";

const useCloseObjectives = (selectedItems, close) => {
  const selectedItemIds = [];
  selectedItems?.map((item) => {
    return selectedItemIds.push(item.id);
  });

  const [, executePUT] = useObjectives(
    {
      method: "PUT",
      url: "closeObjectives",
      data: selectedItemIds,
    },
    {
      manual: true,
    }
  );

  const setUpdateToggle = useCloseObjectiveStore((state) => state.setUpdateToggle);

  const onCloseObjectives = async () => {
    try {
      await executePUT();
      close();
      SendToast("Your selected objectives were successfully closed", "success");
      setUpdateToggle((prev) => !prev);
    } catch (error) {
      SendToast("There was a problem closing your objective(s)", "error");
      console.error(error);
    }
  };

  return onCloseObjectives;
};

export default useCloseObjectives;
